import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Submission } from 'src/types/shared/Assessments';

export const fetchCompleteSubmissionsForChallengeRequest = createAction(
    'fetchCompleteSubmissionsForChallengeRequest',
);
export const fetchCompleteSubmissionsForChallengeSuccess = createAction<Submission[]>(
    'fetchCompleteSubmissionsForChallengeSuccess',
);
export const fetchCompleteSubmissionsForChallengeFailure = createAction(
    'fetchCompleteSubmissionsForChallengeFailure',
);

export const fetchCompleteSubmissionsForChallenge = (challengeID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchCompleteSubmissionsForChallengeRequest());
    try {
        const { data } = await api.get<Submission[]>(
            `admin/challengeapplications/challenge/${challengeID}/complete`,
        );

        dispatch(fetchCompleteSubmissionsForChallengeSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchCompleteSubmissionsForChallengeFailure, e as any);
    }
};
